export default "__VITE_ASSET__BWjW0x$___"